import AuthRepository from './restful/auth.repository';
import HomeRepository from './restful/home.repository';
import SymptomsRepository from './restful/symptoms.repository';
import GoalsRepository from './restful/goals.repository';
import NotificationsRepository from './restful/notifications.repository';
import MedicationRemindersRepository from './restful/medication-reminders.repository';
import NutritionRepository from './restful/nutrition.repository';
import FilesRepository from './restful/files.repository';
import ResourcesRepository from './restful/resources.repository';
import FluidRepository from './restful/fluid.repository';
import OnboardingRepository from './restful/onboarding.repository';
import AppVersionRepository from './restful/app-version.repository';
import FirebasePushRepository from './restful/firebase-push.repository';
import PatientCredentialAuthRepository from './restful/patient-credential-auth.repository';
import BloodTestResultsRepository from './restful/blood-test-results.repository';
import FoodGuideRepository from './restful/food-guide.repository';
import { SERVICE_NAMES } from '@/shared/services/core/service-names';

const repositories = Object.freeze({
  [SERVICE_NAMES.AUTH]: AuthRepository,
  [SERVICE_NAMES.HOME]: HomeRepository,
  [SERVICE_NAMES.SYMPTOMS]: SymptomsRepository,
  [SERVICE_NAMES.GOALS]: GoalsRepository,
  [SERVICE_NAMES.NOTIFICATIONS]: NotificationsRepository,
  [SERVICE_NAMES.MEDICATION_REMINDERS]: MedicationRemindersRepository,
  [SERVICE_NAMES.NUTRITION]: NutritionRepository,
  [SERVICE_NAMES.FILES]: FilesRepository,
  [SERVICE_NAMES.RESOURCES]: ResourcesRepository,
  [SERVICE_NAMES.FLUID]: FluidRepository,
  [SERVICE_NAMES.ONBOARDING]: OnboardingRepository,
  [SERVICE_NAMES.APP_VERSION]: AppVersionRepository,
  [SERVICE_NAMES.FIREBASE_PUSH]: FirebasePushRepository,
  [SERVICE_NAMES.PATIENT_CREDENTIAL_AUTH]: PatientCredentialAuthRepository,
  [SERVICE_NAMES.BLOOD_TEST_RESULTS]: BloodTestResultsRepository,
  [SERVICE_NAMES.FOOD_GUIDE]: FoodGuideRepository,
});

class RepositoryFactory {
  getRepository(serviceName) {
    const repository = repositories[serviceName];
    if (!repository) {
      throw new Error(`Repository not found for service: ${serviceName}`);
    }

    return repository;
  }
}
export default new RepositoryFactory();
